// import fiuuLogo from '../assets/logos/fiuu_logo.png';

export default function PayNetFooter() {
  return (
    <div className="flex items-center justify-center gap-2">
      {/* <span className="text-xs font-semibold text-gray-600">Payment via</span>
      <img
        src={fiuuLogo}
        alt="Fiuu"
        className="h-6 rounded bg-[#0047BA] py-1 pl-2"
      /> */}
      <span className="text-gray-600 text-xs font-semibold">Proudly Made in Southeast Asia ♥️</span>
    </div>
  );
}
